<template>
  <preLoader />
  <div>
    <!--**********************************
  Main wrapper start
***********************************-->
    <div id="main-wrapper">
      <!--**********************************
      Content body start
  ***********************************-->

      <div class="content-body pt-0 mb-5">
        <div class="container-fluid">
          <div class="form-head mb-sm-5 mb-3 d-flex flex-wrap align-items-center pt-3">
            <h2 class="font-w600 title mb-2 mr-auto">{{ lan.admin[7].Commission[0].New_commission_to_report }}</h2>
          </div>

          <div
            v-if="!value && !receivedCommissions.length && !pendingCommissions.length && !upComingCommissions.length">
            <span>
              {{ lan?.commission_blank_page_message }}
            </span>
          </div>

          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">{{ lan.admin[7].Commission[0].Received_Commission }}</h4>
                  <span>Total: <strong>( {{ receivedCommissions.length }} )</strong></span>
                </div>
                <div class="card-body tab-content">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table class="text-center bg-info-hover tr-rounded order-tbl table-received">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>{{ lan.admin[0].admin_portal[0].Opportunity }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Account }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Date }}</th>
                            <th>{{ lan.admin[7].Commission[0].Report_status_Commission }}</th>
                          </tr>
                        </thead>
                        <tbody v-for="(data, index) in receivedCommissions" :key="index"
                          @click="edit(data.commission_id)" class="pointer">
                          <tr>
                            <td>{{ data?.commission_id }}</td>
                            <td v-if="
                              data.customer_account_detail != ''">
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <!-- <td></td> -->
                            <td>{{ data.account_detail.name }}</td>
                            <td>{{ data?.reschedule_date ? data?.reschedule_date : data.conference_end_date }}</td>
                            <td>
                              <span class="badge light badge-success">{{ data.commission_status == "Submitted" ?
                                lan.admin[7].Commission[0].Submitted : data.commission_status }}</span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                      <!-- <div v-if="receivedCommissions.length > 5" class="text-right">
                        <button @click="toggleViewAll_receivedCommissions" class="view-all-less-btn">{{ showAll_receivedCommissions ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">{{ lan.admin[7].Commission[0].Pending_Commission }}</h4>
                  <span>Total: <strong>( {{ pendingCommissions.length }} )</strong></span>
                </div>
                <div class="card-body tab-content">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table class="text-center bg-info-hover tr-rounded order-tbl table-pending">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>{{ lan.admin[0].admin_portal[0].Opportunity }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Account }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Date }}</th>
                            <th>{{ lan.admin[7].Commission[0].Report_status_Commission }}</th>
                          </tr>
                        </thead>
                        <tbody v-for="(data, index) in pendingCommissions" :key="index"
                          @click="edit(data.commission_id)" class="pointer">
                          <tr>
                            <td>{{ data?.commission_id }}</td>
                            <td v-if="
                              data.customer_account_detail != ''">
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else>
                            </td>
                            <td>{{ data.account_detail.name }}</td>
                            <td>{{ data?.reschedule_date ? data?.reschedule_date : data.conference_end_date }}</td>
                            <td v-if="data.commission_status == 'Submitted'">
                              <span class="badge light badge-success">{{ data.commission_status }}</span>
                            </td>
                            <td v-else>
                              <span class="badge light"
                                :class="data.commission_status == 'New' ? 'badge-info' : 'badge-warning'">{{
                                  data.commission_status == "New" ? lan.admin[7].Commission[0].New :
                                    data.commission_status }}</span>
                            </td>
                          </tr>
                          <div class="lds-ellipsis" v-show="value">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </tbody>
                      </table>
                      <!-- <div v-if="pendingCommissions.length > 5" class="text-right">
                        <button @click="toggleViewAll_pendingCommissions" class="view-all-less-btn">{{ showAll_pendingCommissions ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">{{ lan.admin[7].Commission[0].Upcoming_Commission }}</h4>
                  <span>Total: <strong>( {{ upComingCommissions.length }} )</strong></span>
                </div>
                <div class="card-body tab-content">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table class="text-center bg-info-hover tr-rounded order-tbl table-upcoming">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>{{ lan.admin[0].admin_portal[0].Opportunity }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Account }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Date }}</th>
                            <th>{{ lan.admin[7].Commission[0].Report_status_Commission }}</th>
                          </tr>
                        </thead>
                        <tbody v-for="(data, index) in upComingCommissions" :key="index"
                          @click="edit(data.commission_id)" class="pointer">
                          <tr>
                            <td>{{ data?.commission_id }}</td>
                            <td v-if="
                              data.customer_account_detail != ''">
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else></td>
                            <td>{{ data.account_detail.name }}</td>
                            <td>{{ data?.reschedule_date ? data?.reschedule_date : data.conference_end_date }}</td>
                            <td>
                              <span class="badge light"
                                :class="data.commission_status == 'New' ? 'badge-success' : 'badge-warning'">{{
                                  data.commission_status }}</span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                      <!-- <div v-if="upComingCommissions.length > 5" class="text-right">
                        <button @click="toggleViewAll_upComingCommissions" class="view-all-less-btn">{{ showAll_upComingCommissions ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">{{ lan.admin[0].admin_portal[0].invoiced_commissions }}</h4>
                  <span>Total: <strong>( {{ invoicedCommissions.length }} )</strong></span>
                </div>
                <div class="card-body tab-content">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table class="text-center bg-info-hover tr-rounded order-tbl table-invoiced">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>{{ lan.admin[0].admin_portal[0].Opportunity }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Account }}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Date }}</th>
                            <th>{{ lan.admin[7].Commission[0].Report_status_Commission }}</th>
                          </tr>
                        </thead>
                        <tbody v-for="(data, index) in invoicedCommissions" :key="index"
                          @click="edit(data.commission_id)" class="pointer">
                          <tr>
                            <td>{{ data?.commission_id }}</td>
                            <td v-if="data.customer_account_detail != ''">
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else></td>
                            <td>{{ data.account_detail.name }}</td>
                            <td>{{ data?.reschedule_date ? data?.reschedule_date : data.conference_end_date }}</td>
                            <td>
                              <span class="badge light badge-success">{{ data.commission_status == 'Invoiced' ? lan.admin[0].admin_portal[0].Invoiced : data.commission_status }}</span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                      <!-- <div v-if="invoicedCommissions.length > 5" class="text-right">
                        <button @click="toggleViewAll_invoicedCommissions" class="view-all-less-btn">{{ showAll_invoicedCommissions ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-xxl-12">
            <div class="row"></div>
          </div>
          <!-- <pagination
                  :current_page="current_page"
                  :total="total"
                  :per_page="per_page"
                  :totalPages="totalPages"
                  :loadingPageButton="loadingPageButton"
                  @page-change="getCommissions"
                /> -->
        </div>
      </div>
      <!--**********************************
      Content body end
  ***********************************-->
    </div>
    <!--**********************************
  Main wrapper end
***********************************-->
  </div>
</template>
<script>
import axios from "axios";
import pagination from "../../../components/partials/pagination.vue";
// @ is an alias to /src

export default {
  name: "Commission",
  components: {
    pagination
  },
  data() {
    return {
      commissionDetails: "",
      value: true,
      receivedCommissions: [],
      pendingCommissions: [],
      upComingCommissions: [],
      invoicedCommissions: [],
      showAll_receivedCommissions: false,
      showAll_pendingCommissions: false,
      showAll_upComingCommissions: false,
      showAll_invoicedCommissions: false,

      loadingPageButton: 0,

      current_page: 0,
      per_page: 0,
      total: 0,
      totalPages: 0,
    };
  },

  computed: {
    lan() {
      return this.$store.getters.whichLanguage
    },
    displayed_receivedCommissions() {
      return this.showAll_receivedCommissions ? this.receivedCommissions : this.receivedCommissions.slice(0, 5);
    },
    displayed_pendingCommissions() {
      return this.showAll_pendingCommissions ? this.pendingCommissions : this.pendingCommissions.slice(0, 5);
    },
    displayed_upComingCommissions() {
      return this.showAll_upComingCommissions ? this.upComingCommissions : this.upComingCommissions.slice(0, 5);
    },
    displayed_invoicedCommissions() {
      return this.showAll_invoicedCommissions ? this.invoicedCommissions : this.invoicedCommissions.slice(0, 5);
    },

  },

  methods: {
    getCommissions(page) {
      this.loadingPageButton = page
      axios
        .get(axios.defaults.baseURL + "commissions" + (typeof page === "number" && page > 0 ? `?page=${page}` : ""), {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.commissionDetails = res.data.data.data;
          this.current_page = res.data.data.current_page,
            this.per_page = res.data.data.per_page,
            this.total = res.data.data.total,
            this.totalPages = res.data.data.last_page,
            console.log("commissionDetails", this.commissionDetails);

          this.pendingCommissions = []
          this.upComingCommissions = []
          this.receivedCommissions = []
          this.invoicedCommissions = []
          // pending commission data start
          for (let i = 0; i < this.commissionDetails.length; i++) {
            let today = new Date();
            let commission = this.commissionDetails[i];
            let endDate = new Date(commission.conference_end_date);
            let reschedule_date = commission.reschedule_date != null ? new Date(commission.reschedule_date) : "";

            if (commission.commission_status == "Invoiced" || commission.commission_status == "Recived") {
              this.invoicedCommissions.push(commission);
            }
            else if (endDate < today && commission.commission_status != "Submitted" || commission.commission_status == "Revert") {
              // Add the commission to the pendingCommissions array
              this.pendingCommissions.push(commission);
            }
            else if (commission.commission_status == 'Submitted') {

              this.receivedCommissions.push(commission)
            }
            // else if(reschedule_date != 'Invalid Date' ? reschedule_date > today : (endDate > today && commission.quote_detail.status == 'Accepted')){
            else if ((reschedule_date != "") ? reschedule_date > today : endDate > today) {
              this.upComingCommissions.push(commission)
            }

          }
          this.sortByDateDesc(this.receivedCommissions);
          this.sortByDateDesc(this.pendingCommissions);
          this.sortByDateAsc(this.upComingCommissions);
          this.sortByDateDesc(this.invoicedCommissions);
          this.value = false;
          // pending commission data end
        })
        .catch((err) => {
          this.value = false;
          this.$store.dispatch("checkErrorAndSendToast", [
            err.response,
            "error",
          ]);
        });
    },
    toggleViewAll_receivedCommissions() {
      this.showAll_receivedCommissions = !this.showAll_receivedCommissions;
    },
    toggleViewAll_pendingCommissions() {
      this.showAll_pendingCommissions = !this.showAll_pendingCommissions;
    },
    toggleViewAll_upComingCommissions() {
      this.showAll_upComingCommissions = !this.showAll_upComingCommissions;
    },
    toggleViewAll_invoicedCommissions() {
      this.showAll_invoicedCommissions = !this.showAll_invoicedCommissions;
    },
    sortByDateAsc(list) {
      const getDate = (item) => {
        const d = item.reschedule_date ? new Date(item.reschedule_date) : new Date(item.conference_end_date);
        return Number.isNaN(d.getTime()) ? new Date(0) : d;
      };
      list.sort((a, b) => getDate(a) - getDate(b));
    },
    sortByDateDesc(list) {
      const getDate = (item) => {
        const d = item.reschedule_date ? new Date(item.reschedule_date) : new Date(item.conference_end_date);
        return Number.isNaN(d.getTime()) ? new Date(0) : d;
      };
      list.sort((a, b) => getDate(b) - getDate(a));
    },
    edit(id) {
      localStorage.setItem("editID", id);
      this.$router.push({ name: "Edit Commission", params: { id: id }, });
    },
  },
  mounted() {
    // for top load page
    window.scrollTo(0, 0);
    this.getCommissions()


  },
};
</script>

<style scoped>
.table-received thead {
  background: rgba(40, 167, 69, 0.14);
}
.table-received tbody tr:hover {
  background: rgba(40, 167, 69, 0.08);
}

.table-pending thead {
  background: rgba(255, 193, 7, 0.14);
}
.table-pending tbody tr:hover {
  background: rgba(255, 193, 7, 0.1);
}

.table-upcoming thead {
  background: rgba(23, 162, 184, 0.14);
}
.table-upcoming tbody tr:hover {
  background: rgba(23, 162, 184, 0.1);
}

.table-invoiced thead {
  background: rgba(108, 117, 125, 0.14);
}
.table-invoiced tbody tr:hover {
  background: rgba(108, 117, 125, 0.1);
}

.table-received,
.table-pending,
.table-upcoming,
.table-invoiced {
  width: 100%;
  table-layout: fixed;
}

.table-received th,
.table-received td,
.table-pending th,
.table-pending td,
.table-upcoming th,
.table-upcoming td,
.table-invoiced th,
.table-invoiced td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-received th:nth-child(1),
.table-received td:nth-child(1),
.table-pending th:nth-child(1),
.table-pending td:nth-child(1),
.table-upcoming th:nth-child(1),
.table-upcoming td:nth-child(1),
.table-invoiced th:nth-child(1),
.table-invoiced td:nth-child(1) {
  width: 10%;
}

.table-received th:nth-child(2),
.table-received td:nth-child(2),
.table-pending th:nth-child(2),
.table-pending td:nth-child(2),
.table-upcoming th:nth-child(2),
.table-upcoming td:nth-child(2),
.table-invoiced th:nth-child(2),
.table-invoiced td:nth-child(2) {
  width: 30%;
}

.table-received th:nth-child(3),
.table-received td:nth-child(3),
.table-pending th:nth-child(3),
.table-pending td:nth-child(3),
.table-upcoming th:nth-child(3),
.table-upcoming td:nth-child(3),
.table-invoiced th:nth-child(3),
.table-invoiced td:nth-child(3) {
  width: 20%;
}

.table-received th:nth-child(4),
.table-received td:nth-child(4),
.table-pending th:nth-child(4),
.table-pending td:nth-child(4),
.table-upcoming th:nth-child(4),
.table-upcoming td:nth-child(4),
.table-invoiced th:nth-child(4),
.table-invoiced td:nth-child(4) {
  width: 20%;
}

.table-received th:nth-child(5),
.table-received td:nth-child(5),
.table-pending th:nth-child(5),
.table-pending td:nth-child(5),
.table-upcoming th:nth-child(5),
.table-upcoming td:nth-child(5),
.table-invoiced th:nth-child(5),
.table-invoiced td:nth-child(5) {
  width: 20%;
}
</style>
